import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useMutation } from '@apollo/client';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';
import IconHeart from 'components/icons/iconHeart';
import { colorGrayLight2, colorRed } from 'styles/layout/colors';
import useProductCardContext from 'data-hooks/useProductCardContext';
import useProductWishlistEvents from 'data-hooks/useEvents/useProductWishlistEvent';
import useUserData from 'data-hooks/useUserData';
import useSetFavoriteModalState from 'global-state/favoriteModalState/useSetFavoriteModalState';
import { FAVORITE_PRODUCT_V2 } from 'mocks/mutations';
const ProductCardFavoriteButton = () => {
  const $ = _c(26);
  const product = useProductCardContext();
  const {
    productWishlistEvent
  } = useProductWishlistEvents();
  const isFavorited = product?.isFavorited ?? false;
  const t0 = !isFavorited;
  let t1;
  if ($[0] !== product.id || $[1] !== t0) {
    t1 = {
      userFavoriteActionV2: {
        id: product.id,
        status: t0,
        __typename: "FavResponseV2"
      }
    };
    $[0] = product.id;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [{
      query: GET_FAVORITED_PRODUCT_IDS
    }];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = {
      optimisticResponse: t1,
      update: _temp,
      refetchQueries: t2
    };
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const [toggleFavorite] = useMutation(FAVORITE_PRODUCT_V2, t3);
  const {
    isLoggedIn
  } = useUserData();
  const setFavoriteModalState = useSetFavoriteModalState();
  let t4;
  if ($[6] !== isFavorited || $[7] !== isLoggedIn || $[8] !== product.id || $[9] !== productWishlistEvent || $[10] !== setFavoriteModalState || $[11] !== toggleFavorite) {
    t4 = event => {
      event.stopPropagation();
      event.preventDefault();
      if (!product.id) {
        return;
      }
      if (!isLoggedIn) {
        setFavoriteModalState({
          productId: product.id
        });
      } else {
        toggleFavorite({
          variables: {
            productID: product.id
          }
        });
        productWishlistEvent(isFavorited);
      }
    };
    $[6] = isFavorited;
    $[7] = isLoggedIn;
    $[8] = product.id;
    $[9] = productWishlistEvent;
    $[10] = setFavoriteModalState;
    $[11] = toggleFavorite;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const addProductToFav = t4;
  const t5 = !isFavorited;
  let t6;
  if ($[13] !== isFavorited || $[14] !== t5) {
    t6 = classNames("w-9 h-9 rounded-full flex items-center justify-center", {
      "opacity-100 bg-red": isFavorited,
      "opacity-0 bg-white group-hover/product-card:opacity-100": t5
    });
    $[13] = isFavorited;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isFavorited) {
    t7 = classNames("w-[0.875rem] ", {
      "animate-heartbeat": isFavorited
    });
    $[16] = isFavorited;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = isFavorited ? colorRed : colorGrayLight2;
  const t9 = isFavorited ? "white" : colorGrayLight2;
  let t10;
  if ($[18] !== t7 || $[19] !== t8 || $[20] !== t9) {
    t10 = <IconHeart className={t7} color={t8} fill={t9} />;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== addProductToFav || $[23] !== t10 || $[24] !== t6) {
    t11 = <button type="button" data-xc="ProductCardFavoriteButton" className={t6} onClick={addProductToFav}>{t10}</button>;
    $[22] = addProductToFav;
    $[23] = t10;
    $[24] = t6;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
};
export default ProductCardFavoriteButton;
function _temp(cache, t0) {
  const {
    data: t1
  } = t0;
  const {
    userFavoriteActionV2
  } = t1;
  const data = cache.readQuery({
    query: GET_FAVORITED_PRODUCT_IDS
  });
  const productIds = data?.productIds;
  if (!productIds) {
    return;
  }
  const newFavoritedProductIds = userFavoriteActionV2?.status ? [...productIds, userFavoriteActionV2?.id] : productIds.filter(id => id !== userFavoriteActionV2?.id);
  cache.writeQuery({
    query: GET_FAVORITED_PRODUCT_IDS,
    data: {
      productIds: newFavoritedProductIds
    }
  });
}